import { FILTER_NAME_SUB_MENU } from '../../../constants/filter'

export const CONTRACT_EXCLUDE_FILTERS = [FILTER_NAME_SUB_MENU]

export const ENTITY_TAB_CONTRACTS_SUB_TAB_QA_NAME = 'entityTabContractsSubTab'

export const ENTITY_TAB_CONTRACTS_DEFAULT_QA_NAME = {
  addNew: 'entityTabContractsAddNew',
  table: 'entityTabContractsTable',
}

export const ENTITY_TAB_CONTRACTS_ITEM_ACTION = {
  Archive: 'archive',
  Edit: 'edit',
}

export const ENTITY_TAB_CONTRACTS_ITEM_ACTIONS = [
  {
    label: 'ContractTable.EditActionKey',
    value: ENTITY_TAB_CONTRACTS_ITEM_ACTION.Edit,
  },
  {
    label: 'ContractTable.ArchiveActionKey',
    value: ENTITY_TAB_CONTRACTS_ITEM_ACTION.Archive,
  },
]

export const CONTRACT_ITEM_ACTION_PERMISSION = {
  [ENTITY_TAB_CONTRACTS_ITEM_ACTION.Archive]: 'can_archive',
  [ENTITY_TAB_CONTRACTS_ITEM_ACTION.Edit]: 'can_edit',
}

export const CONTRACTS_MASS_ACTION_NAMES = {
  [ENTITY_TAB_CONTRACTS_ITEM_ACTION.Archive]: 'delete',
}
